import axios from "axios";
import * as constants from "../Constatnts";

// Helper to safely get token
const getTokenFromState = (getState) => {
  const state = getState();
  let token = "";

  if (
    state &&
    state.hasOwnProperty("user") &&
    state.user &&
    state.user.hasOwnProperty("uat")
  ) {
    token = state.user.uat;
  }

  return token;
};

// Common error handler (NO optional chaining)
const handleError = (error) => {
  if (
    error &&
    error.hasOwnProperty("response") &&
    error.response &&
    error.response.hasOwnProperty("data")
  ) {
    throw error.response.data;
  } else {
    throw error;
  }
};

// ================= API FUNCTIONS ================= //

export function createOnlinePayment (payload)  {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.post(
        `${constants.API_URL}/payment/create`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};


export function getSMSTemplateBySMSType (smsType,storeID)  {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.get(
        `${constants.API_URL}/crm/smstemplatebysmstype?smsType=${smsType}&storeID=${storeID}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};





export function saveLogisticProvider (name,
  email,
  password,
  isActive,
  deliveryType,
  storeId,
  category
)  {
  return async (dispatch, getState) => {
    try {
        const payload = {
      name,
      email,
      password,
      isActive,
      deliveryType,
      storeId,
      category
    };
      const token = getTokenFromState(getState);

      const response = await axios.post(
        `${constants.API_URL}/logistic/provider`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};


export function getLogisticProvider ()  {
  return async (dispatch, getState) => {
    try {
   
      const token = getTokenFromState(getState);

      const response = await axios.get(
        `${constants.API_URL}/logistic/provider`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};

